module.exports = __webpack_public_path__ + "assets/contact.svg";